import { service as request } from '@/libs/request'
import { requireChatResponse } from '@/utils/chat-response.mjs'
import axios from 'axios'
import config from '@/apis/config'
import { getToken } from '@/utils/auth'

// 统一处理业务错误/null，失败时不把现有项目列表误清空。
const call = async (action, data = {}) => requireChatResponse(
  await request.post(`useragent/api.Project/${action}`, data), '项目请求失败，请稍后重试').data
export const listProjects = data => call('list', data)
export const projectOptions = () => call('options')
export const projectDetail = projectGuid => call('detail', { projectGuid })
export const createProject = data => call('create', data)
export const updateProject = data => call('update', data)
export const deleteProject = data => call('delete', data)
// 独立探针有180秒总预算；不改变其它项目请求的默认超时。
export const verifyProjectModel = async modelRef => requireChatResponse(await request.post(
  'useragent/api.Project/verifyModel', { modelRef }, { timeout: 195000 }), '主管能力验证未完成，请稍后重试').data
const planCall = async (action, data) => requireChatResponse(await request.post(
  `useragent/api.ProjectPlan/${action}`, data), '项目事项请求失败').data
export const listProjectPlan = projectGuid => planCall('list', { projectGuid })
export const saveProjectPlan = data => planCall('save', data)
const taskCall = async (action, data) => requireChatResponse(await request.post(
  `useragent/api.ProjectTask/${action}`, data), '项目任务请求失败').data
export const listProjectTasks = projectGuid => taskCall('list', { projectGuid })
export const sendProjectTask = data => taskCall('send', data)
export const projectTaskDetail = data => taskCall('detail', data)
export const projectTaskEvents = data => taskCall('events', data)
export const decideProjectApproval = data => taskCall('decideApproval', data)
export const provideProjectInput = data => taskCall('provideInput', data)
export const configureProjectMedia = data => taskCall('configureMedia', data)
export const cancelProjectRun = data => taskCall('cancel', data)
export const projectConversation = async (action, data) => requireChatResponse(await request.post(
  `useragent/api.ProjectConversation/${action}`, data), '主管对话请求失败，请稍后重试').data
export const projectAutomation = async (action, data) => requireChatResponse(await request.post(
  `useragent/api.ProjectAutomation/${action}`, data), '定时任务请求失败').data
export const projectAssets = async projectGuid => requireChatResponse(await request.post(
  'useragent/api.ProjectAsset/list', { projectGuid }), '共享资料加载失败').data
export const downloadProjectAsset = async data => requireChatResponse(await request.post(
  'useragent/api.ProjectAsset/download', data), '资料下载失败').data
export const uploadProjectAsset = async (projectGuid, file, assetGuid) => {
  const body = new FormData(); body.append('file', file)
  const query = new URLSearchParams({ projectGuid, token: getToken(), app_type: 'xiaoyipc', app_guid: 'xiaoyipc' })
  if (assetGuid) query.set('assetGuid', assetGuid)
  const response = await axios.post(`${config.baseUrl}useragent/api.ProjectAsset/upload?${query}`, body)
  return requireChatResponse(response.data, '资料上传失败').data
}
